/*!
 * 
 * ------
 * Note: customizing files reduces the store's ability to auto-update the theme.
 *
 * Disclaimer:
 * This is a non minified version of a core js file, you can swap out the liquid / HTML link from the minified file if you choose to utilize this one. Any usage of these files is at the merchant/app/expert/agency's own risk, we take no responsibility for custom code changes. Support offerings from We Are Eight will be limited to rolling back to the latest theme version if these are utilized.
 *
 * License and acceptance of usage:
 *
 * Copyright (C) We Are Eight LTD  - All Rights Reserved
 * This file is part of Influence theme provided for usage on Shopify online stores only.
 * Unauthorized usage and or modification of this file outside of this Influence utilized on a Shopify store without a valid license, is strictly prohibited.
 * Unauthorized copying or distribution of this file, via any medium is strictly prohibited.
 * Proprietary and confidential
 *
 * More information and official contact details: weareeight.com
 * ------
 *
 */
/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 845:
/***/ ((module) => {

        !function (e, d) { true ? module.exports = d() : 0 }(self, (function () { return (() => { "use strict"; var e = {}; return ((e, d) => { Object.defineProperty(d, "__esModule", { value: !0 }), d.isArmadaLoaded = void 0, d.isArmadaLoaded = e => { var d, o; const a = !0 === (null === (o = null === (d = window.eight) || void 0 === d ? void 0 : d.armada) || void 0 === o ? void 0 : o.loaded); if (!e) return a; a ? e() : document.addEventListener("ARMADA:LOADED", e) }, d.default = d.isArmadaLoaded })(0, e), e })() }));

        /***/
})

    /******/
});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
      /******/
}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
      /******/
};
/******/
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
    /******/
}
/******/
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
      /******/
};
    /******/
})();
/******/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for (var key in definition) {
/******/ 				if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
          /******/
}
        /******/
}
      /******/
};
    /******/
})();
/******/
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
    /******/
})();
  /******/
  /************************************************************************/
  var __webpack_exports__ = {};
  // This entry need to be wrapped in an IIFE because it need to be in strict mode.
  (() => {
    "use strict";
/* harmony import */ var _weareeight_armada_dist_utils_isArmadaLoaded__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(845);
/* harmony import */ var _weareeight_armada_dist_utils_isArmadaLoaded__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_weareeight_armada_dist_utils_isArmadaLoaded__WEBPACK_IMPORTED_MODULE_0__);


    class ProductForm extends HTMLElement {
      constructor() {
        super();

        if (!this.getAttribute('product')) return;

        this.sectionId = this.getAttribute('section-id');
        this.setButton = this.setButton.bind(this);
      }

      connectedCallback() {
        (0, _weareeight_armada_dist_utils_isArmadaLoaded__WEBPACK_IMPORTED_MODULE_0__.isArmadaLoaded)(this.init.bind(this));
        document.addEventListener('ARMADA:TRANSLATION:SYNC', this.setButton(false, false));
      }

      // Render blocks in the order chosen in the theme editor.
      renderBlocks() {
        if (!this.blocks || this.hasBlocks) return;

        this.blocks.forEach((block) => {
          if (!block) return;
          this.appendChild(block.cloneNode(true));
        });
        this.setAttribute('has-blocks', true);
      }

      init() {
        if (this.isQuickAdd || !this.product) return;

        this.templateContent = this.querySelector(`template#product-form-${this.sectionId}-${this.product.id}`).content;

        if (this.isStickyForm) this.renderBlocks();

        this.loadingButtonHtml = this.templateContent.querySelector('[data-button-loading]').outerHTML;

        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('variant')) {
          this.currentVariant = this.product.variants.find((variant) => variant.id == parseInt(urlParams.get('variant')));
          if (!this.currentVariant) {
            this.currentVariant = this.forceSelection ? null : window.eight.productEngine.firstAvailableVariant(this.product);
          }
        } else {
          this.currentVariant = this.forceSelection ? null : window.eight.productEngine.firstAvailableVariant(this.product);
        }

        this.optionInputs = [];

        if (this.optionType === 'dropdowns') {
          this.optionInputs = this.querySelectorAll('[data-name="product-option-select"]');
        }
        else if (this.optionType === 'buttons') {
          this.optionInputs = this.querySelectorAll('[data-name="product-option-radio"]');
        }

        this.buttons = this.querySelectorAll('[data-name="product-submit"][data-product-form-block="true"]');
        this.buttonWraps = this.querySelectorAll('[data-name="product-submit-wrapper"][data-product-form-block="true"]');

        this.setInitialValues();
        this.setEventListeners();

        window.eight.armada.elementRegistry.register({ key: 'product-form', assetPath: '/assets/component-product-form.js' });
        if (!this.currentVariant || !this.currentVariant.available) {
          const interval = setInterval(() => {
            let magicBtn = document.querySelectorAll('.magic-buy-btn__parent');
            if (magicBtn.length > 0) {
              clearInterval(interval)
              magicBtn.forEach(ele => {
                ele.classList.add('hidden');
              });
            }
          }, 100);
        }
        this.dummyBuyNowButton()
      }


      dummyBuyNowButton = () => {
        document.addEventListener("click", (e) => {
          if (e.target.closest('.dummy-buy-now-btn')) {
            e.preventDefault();
             const errorMessage = this.querySelector('.full-product-options .error-message');
             if(errorMessage){
              errorMessage.classList.add("active")
              setTimeout(() => {
                errorMessage.classList.remove("active")
              }, 5000);
             }

            // Start 5s window: if user selects a variant before it expires, auto trigger Buy Now
            if (this._waitingForVariantTimeout) clearTimeout(this._waitingForVariantTimeout);
            this._waitingForVariant = true;
            this._waitingButtonType = 'buynow';
            this._waitingForVariantTimeout = setTimeout(() => {
              this._waitingForVariant = false;
              this._waitingForVariantTimeout = null;
              this._waitingButtonType = null;
            }, 5000);

             // Try multiple selectors to find the variant options div
          const variantOptionsDiv =
            this.querySelector('.product-option-wrapper[data-id="product-option-wrapper"]') ||
            document.querySelector('.product-option-wrapper[data-id="product-option-wrapper"]') ||
            this.closest('product-form').querySelector('.product-option-wrapper[data-id="product-option-wrapper"]');

            if (variantOptionsDiv) {
              setTimeout(() => {
                const rect = variantOptionsDiv.getBoundingClientRect();
                let y;
                if (rect.top < 0) {
                  y = rect.bottom + window.pageYOffset - window.innerHeight + 80;
                } else {
                  y = rect.top + window.pageYOffset - 100;
                }
                window.scrollTo({
                  top: y,
                  behavior: 'smooth'
                });
                variantOptionsDiv.classList.add('highlight-option');
                setTimeout(() => {
                  variantOptionsDiv.classList.remove('highlight-option');
                }, 2000);
              }, 100);
            }
          }
        });
      };



      setPrice() {
        this.priceElem = document.querySelectorAll(`product-price[section-id="${this.sectionId}"]`);
        this.priceElem.forEach(priceEl => {
          let discountVal = priceEl.getAttribute('discount-value');
          let discountAmt = 0;

          if (discountVal && discountVal != 'hide' && this.currentVariant && this.currentVariant.compare_at_price) {
            discountVal == 'value' ?
              discountAmt = this.currentVariant.compare_at_price - this.currentVariant.price :
              discountAmt = Math.round((this.currentVariant.compare_at_price - this.currentVariant.price) * 100 / this.currentVariant.compare_at_price / 1) + '%';
          }

          if (priceEl && this.currentVariant) {
            priceEl.setAttribute('price', this.currentVariant.price);
            priceEl.setAttribute('compare-at', this.currentVariant.compare_at_price);
            priceEl.setAttribute('discount', `${discountAmt}`);
            priceEl.setAttribute('unit-price', this.currentVariant.unit_price);
            priceEl.setAttribute('unit-price-measurement', JSON.stringify(this.currentVariant.unit_price_measurement));
          }

          if (priceEl.classList.contains('hidden')) {
            priceEl.classList.remove('hidden')
          }
        });

        this.hideSummaryPrice();
      }

      hideSummaryPrice() {
        if (this.summaryPriceIsHidden) return;

        this.summaryPrices = document.querySelectorAll('[data-armada-selector="product-form-summary-price"]');
        if (this.summaryPrices.length) {
          this.summaryPrices.forEach(summaryPrice => {
            summaryPrice.classList.add('hidden');
          });
          this.setAttribute('summary-price-hidden', true);
        }
      }

      setPickup() {
        const pickupElem = document.querySelector(`pickup-availability[section-id="${this.sectionId}"]`);
        if (!pickupElem) return;

        const id = this.currentVariant ? this.currentVariant.id : null;
        pickupElem.setAttribute('data-variant-id', id);
      }

      setInventory() {
        this.inventoryElem = document.querySelector(`stock-level-indicator[section-id="${this.sectionId}"]`);
        if (!this.inventoryElem) return;

        const id = this.currentVariant ? this.currentVariant.id : null;
        this.inventoryElem.setAttribute('variant-id', id);
      }

      setSku() {
        this.skuElem = this.querySelector('[data-armada-selector="product-form-sku"]');
        if (!this.skuElem) return;

        const sku = this.currentVariant ? this.currentVariant.sku : '';
        this.skuElem.textContent = sku;
      }

      setValues() {
        if (!this.currentVariant || !this.optionInputs || !this.currentVariant.options) return;

        this.currentVariant.options.forEach((option, index) => {
          if (this.optionType === 'dropdowns') {
            if (this.optionInputs?.length > 0) {
              this.optionInputs[index].value = option;
            }
          }
          else {
            // Radio buttons.
            this.optionInputs.forEach((input) => {
              // Case insensitive.
              if (input.value.localeCompare(option, undefined, { sensitivity: 'base' }) === 0) {
                input.checked = true;
              }
            });
          }
        });
      }

      setBasicSelectValue() {
        // Note that the basic select could be hidden.
        if (!this.basicSelect) return;

        if (!this.currentVariant) {
          // Set to 'unavailable' state - 'Choose' button text.
          this.basicSelect.value = '';
        }
        else {
          this.basicSelect.value = this.currentVariant.id;
        }
      }

      setInstallmentsSelectValue() {
        if (!this.installmentsSelect) return;

        if (!this.currentVariant) {
          this.installmentsSelect.value = '';
        }
        else {
          this.installmentsSelect.value = this.currentVariant.id;
        }

        // Emit the change event on the installments form to trigger the banner update
        const event = new Event('change', { bubbles: true });
        this.installmentsSelect.dispatchEvent(event);

        // Unhide installments form
        const installmentsForm = this.installmentsSelect.closest('form');
        if (installmentsForm && installmentsForm.classList.contains('hidden')) {
          installmentsForm.classList.remove('hidden');
        }
      }

      get dynamicButtonsForm() {
        return this.querySelector('#dynamic-buttons-form') ? this.querySelector('#dynamic-buttons-form') : null;
      }

      checkDynamicButtons() {
        if (!this.dynamicButtonsForm) return;

        let variantAvailable;
        if (this.currentVariant) {
          if (!this.currentVariant.available) {
            variantAvailable = false; //soldout variant
          } else {
            variantAvailable = true;
          }
        } else {
          variantAvailable = false; //non-existent/unavailable variant
        };

        // hide DynBtns if variant is sold-out or if it doesn't exist
        if (!variantAvailable) {
          this.dynamicButtonsForm.classList.add('hidden');
        } else {
          this.dynamicButtonsForm.classList.remove('hidden');

          this.setDynamicFormVariantId();
        }
      }

      setDynamicFormVariantId() {
        const dynamicFormIds = this.querySelectorAll('input[data-name="dynamic_buttons_variant_id"]');
        if (!dynamicFormIds || !this.currentVariant) return;

        dynamicFormIds.forEach((IdInput) => {
          IdInput.value = this.currentVariant.id;
        });
      }

      setInitialValues() {
        if (this.forceSelection) return;
        this.setValues();
        this.setBasicSelectValue();
      }

      setEventListeners() {
        document.addEventListener(`${window.eight.constants.events["ARMADA:VARIANT:CHANGE"]}`, this.handleVariantChangeEvent.bind(this));

        if (this.basicSelect) {
          this.basicSelect.addEventListener('change', this.handleOptionChange.bind(this));
        }

        this.optionInputs.forEach((select) => {
          select.addEventListener('change', this.handleOptionChange.bind(this));
        });

        if (this.buttons) {
          this.buttons.forEach((btn) => {
            btn.addEventListener('click', this.handleButtonClick.bind(this));
          });
        }
      }

      handleOptionChange(e) {
        // Do we have a selection in all options?
        if (!this.allOptionsChosen) return;

        const prevTitle = this.currentVariant ? this.currentVariant.title : '';

        // Basic product select has changed.
        if (e.target.getAttribute('name') === 'id') {
          const varId = parseInt(e.target.options[e.target.selectedIndex].value);
          this.currentVariant = this.product.variants.find((variant) => variant.id === varId);
        }
        else {
          // One of the multiple options has changed.
          this.currentVariant = window.eight.productEngine.findVariant(this.product, this.optionIndexes);
        }

        this.setButton();

        if (window.eight.eventsEngine && this.currentVariant && this.currentVariant.title !== prevTitle) {
          window.eight.eventsEngine.namedEvents.changeVariant(this.product.id, this.currentVariant.id, this.currentVariant, this.scopeId);
        }
        const btn1 = document.querySelector('.shopify-payment-button.button-1');
        if(btn1){
          btn1.classList.remove("hidden")
        }
        const btn2 = document.querySelector('.shopify-payment-button.button-2');
        if(btn2){
          btn2.classList.add("hidden")
        }

        // If we're in the 5s window and the error is now gone (variant selected), auto-trigger
        if (this._waitingForVariant && document.querySelector('.error-message.active')) {
          clearTimeout(this._waitingForVariantTimeout);
          this._waitingForVariant = false;
          this._waitingForVariantTimeout = null;
          const buttonType = this._waitingButtonType;
          this._waitingButtonType = null;

          if (buttonType === 'buynow') {
            const gokwikBtn = document.querySelector('.shopify-payment-button.button-1 button');
            if (gokwikBtn) gokwikBtn.click();
          } else {
            this.handleButtonClick(new Event('click'));
          }
        }
      }

      handleButtonClick(e) {
        // This will never fire for sold out / unavailable as those buttons are disabled.
        e.preventDefault();

        //Get all custom properties on the product template
        const productProperties = this.querySelectorAll('[name^=properties]:not([type="checkbox"]):not([type="radio"]):not([disabled]), [name^=properties][type="checkbox"]:not([disabled]):checked, [name^=properties][type="radio"]:not([disabled]):checked');
        const properties = {};

        const errorMessage = this.querySelector('.full-product-options .error-message');
        if (errorMessage) {
          errorMessage.classList.remove('active');
        }

        productProperties.forEach(property => {
          //Construct entry name
          let propertyKey = property.name.substring(
            property.name.lastIndexOf("[") + 1,
            property.name.lastIndexOf("]")
          );

          //Handleize property key (remove spaces between words)
          propertyKey = propertyKey.replace(/\s+/g, '-').toLowerCase();

          //Get entry value
          const propertyValue = property.value;

          //Construct object
          if (!propertyValue) return;
          properties[propertyKey] = propertyValue;
        });

        // Check if all options are selected when force_selection is true
        if (this.forceSelection && !this.allOptionsChosen) {
          if (errorMessage) {
            errorMessage.classList.add('active');
            setTimeout(() => {
              errorMessage.classList.remove('active');
            }, 3000);
          }

          // Start 5s window: if user selects a variant before it expires, auto add to cart
          if (this._waitingForVariantTimeout) clearTimeout(this._waitingForVariantTimeout);
          this._waitingForVariant = true;
          this._waitingButtonType = 'atc';
          this._waitingForVariantTimeout = setTimeout(() => {
            this._waitingForVariant = false;
            this._waitingForVariantTimeout = null;
            this._waitingButtonType = null;
          }, 5000);

          // Try multiple selectors to find the variant options div
          const variantOptionsDiv =
            this.querySelector('.product-option-wrapper[data-id="product-option-wrapper"]') ||
            document.querySelector('.product-option-wrapper[data-id="product-option-wrapper"]') ||
            this.closest('product-form').querySelector('.product-option-wrapper[data-id="product-option-wrapper"]');

          if (variantOptionsDiv) {
            setTimeout(() => {
              const rect = variantOptionsDiv.getBoundingClientRect();
              let y;
              if (rect.top < 0) {
                y = rect.bottom + window.pageYOffset - window.innerHeight + 80;
              } else {
                y = rect.top + window.pageYOffset - 100;
              }
              window.scrollTo({
                top: y,
                behavior: 'smooth'
              });
              variantOptionsDiv.classList.add('highlight-option');
              setTimeout(() => {
                variantOptionsDiv.classList.remove('highlight-option');
              }, 2000);
            }, 100);
          }

          console.warn('No variant selected.');
          return;
        }

        if (this.currentVariant == null || this.currentVariant.id == null) {
          if (errorMessage) {
            errorMessage.classList.add('active');
            setTimeout(() => {
              errorMessage.classList.remove('active');
            }, 3000);
          }

          // Try multiple selectors to find the variant options div
          const variantOptionsDiv =
            this.querySelector('.product-option-wrapper[data-id="product-option-wrapper"]') ||
            document.querySelector('.product-option-wrapper[data-id="product-option-wrapper"]') ||
            this.closest('product-form').querySelector('.product-option-wrapper[data-id="product-option-wrapper"]');

          if (variantOptionsDiv) {
            setTimeout(() => {
              const rect = variantOptionsDiv.getBoundingClientRect();
              let y;
              if (rect.top < 0) {
                y = rect.bottom + window.pageYOffset - window.innerHeight + 80;
              } else {
                y = rect.top + window.pageYOffset - 100;
              }
              window.scrollTo({
                top: y,
                behavior: 'smooth'
              });
              variantOptionsDiv.classList.add('highlight-option');
              setTimeout(() => {
                variantOptionsDiv.classList.remove('highlight-option');
              }, 2000);
            }, 100);
          }

          console.warn('No variant selected or variant does not exist.');
          return;
        }

        this.setButton('loading');

        // Add to cart.
        const formData = {
          items: [
            {
              id: this.currentVariant.id,
              quantity: this.quantity,
              selling_plan: this.sellingPlanId,
              properties: {
                ...properties
              }
            },
          ],
        };

        window.eight.cartEngine.addToCart(
          formData,
          'items',
          this.atcSuccess.bind(this),
          this.atcError.bind(this),
        );
      }

      handleVariantChangeEvent(e) {
        const { variantId, productId, scopeId } = e.detail;

        if (productId !== this.product.id) return;
        if (scopeId != this.scopeId) return;

        this.currentVariant = this.product.variants.find((v) => v.id === variantId);
        this.setPrice();
        this.setPickup();
        this.setInventory();
        this.setSku();
        this.setValues();
        this.setBasicSelectValue();
        this.setInstallmentsSelectValue();
        this.checkDynamicButtons();
        this.setButton();
      }

      atcSuccess(data) {
        this.setButton('added');

        // Go to the cart page if the "Add to cart" action is "page"
        if (this.cartTypePage) {
          window.location = this.cartPageUrl;
        }

        // Change button back to 'add'.
        setTimeout(() => {
          this.setButton(false, true);
        }, window.eight.product.addedTimeout);
        window.sideCart.updateCart(true);
      }

      atcError(data) {
        console.warn('Error adding to cart: ', data);
        this.setButton(false, true);
      }

      setButton(mode = false, reset = false) {
        if (!this.buttons) return;
        let magicBtn = document.querySelectorAll('.magic-buy-btn__parent');

        if (!mode) {
          let buttonText = window.eight.translationEngine.strings.addToCart;
          let disabled = false; // Always enable the button

          // Add to cart
          // Choose
          //    = Variant not pre-selected, cannot add to cart until all options chosen.
          // Sold out
          //    = variant exists but has no stock
          // Unavailable
          //    = Variant does not exist at all
          //      e.g. these ARE available:
          //      M / Blue
          //      L / Red
          //      + User selects L / Blue from dropdowns == unavailable.

          if (this.forceSelection && !this.allOptionsChosen) {
            // Always show "Add to cart" text regardless of option selection
            buttonText = `<svg data-aid="icon-bag" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 15 15" fill="none" class=" inline-block">
      <g clip-path="url(#clip0_152_300)">
      <path d="M0.625 0.625C0.45924 0.625 0.300269 0.690848 0.183058 0.808058C0.065848 0.925268 0 1.08424 0 1.25C0 1.41576 0.065848 1.57473 0.183058 1.69194C0.300269 1.80915 0.45924 1.875 0.625 1.875H1.7375C1.82835 1.87516 1.91685 1.90384 1.99053 1.95699C2.0642 2.01014 2.11933 2.08509 2.14812 2.17125L4.20875 8.35437C4.30063 8.62937 4.31188 8.92438 4.24188 9.20563L4.0725 9.885C3.82312 10.8813 4.59875 11.875 5.625 11.875H13.125C13.2908 11.875 13.4497 11.8092 13.5669 11.6919C13.6842 11.5747 13.75 11.4158 13.75 11.25C13.75 11.0842 13.6842 10.9253 13.5669 10.8081C13.4497 10.6908 13.2908 10.625 13.125 10.625H5.625C5.38125 10.625 5.225 10.425 5.28438 10.1894L5.4125 9.67812C5.43409 9.59165 5.48394 9.51486 5.55414 9.45994C5.62434 9.40503 5.71087 9.37513 5.8 9.375H12.5C12.6313 9.37516 12.7594 9.33395 12.866 9.25721C12.9725 9.18047 13.0522 9.07211 13.0938 8.9475L14.7594 3.9475C14.7907 3.85354 14.7992 3.75349 14.7842 3.6556C14.7693 3.5577 14.7313 3.46476 14.6733 3.38443C14.6154 3.30411 14.5392 3.2387 14.4511 3.19359C14.3629 3.14849 14.2653 3.12498 14.1663 3.125H4.09687C4.00592 3.12497 3.91728 3.09635 3.84348 3.04319C3.76968 2.99003 3.71446 2.91501 3.68562 2.82875L3.09312 1.0525C3.05166 0.927996 2.97205 0.819704 2.86559 0.742973C2.75914 0.666243 2.63123 0.624968 2.5 0.625H0.625ZM5 12.5C4.66848 12.5 4.35054 12.6317 4.11612 12.8661C3.8817 13.1005 3.75 13.4185 3.75 13.75C3.75 14.0815 3.8817 14.3995 4.11612 14.6339C4.35054 14.8683 4.66848 15 5 15C5.33152 15 5.64946 14.8683 5.88388 14.6339C6.1183 14.3995 6.25 14.0815 6.25 13.75C6.25 13.4185 6.1183 13.1005 5.88388 12.8661C5.64946 12.6317 5.33152 12.5 5 12.5ZM12.5 12.5C12.1685 12.5 11.8505 12.6317 11.6161 12.8661C11.3817 13.1005 11.25 13.4185 11.25 13.75C11.25 14.0815 11.3817 14.3995 11.6161 14.6339C11.8505 14.8683 12.1685 15 12.5 15C12.8315 15 13.1495 14.8683 13.3839 14.6339C13.6183 14.3995 13.75 14.0815 13.75 13.75C13.75 13.4185 13.6183 13.1005 13.3839 12.8661C13.1495 12.6317 12.8315 12.5 12.5 12.5Z" fill="white"/>
      </g>
      <defs>
      <clipPath id="clip0_152_300">
      <rect width="15" height="15" fill="currentColor"/>
      </clipPath>
      </defs>
    </svg><span data-armada-button-text="" class="button-text">${window.eight.translationEngine.strings.addToCart}</span>`;

            // Always enable the button - never disable it
            disabled = false;

            this.buttons.forEach((btn) => {
              btn.ariaLabel = window.eight.translationEngine.strings.chooseVariant;
              btn.classList.remove('opacity-20'); // Remove opacity class
            });
          }
          else if (!this.currentVariant) {
            buttonText = window.eight.translationEngine.strings.unavailable;
            disabled = false; // Always enable the button
            this.buttons.forEach((btn) => {
              btn.ariaLabel = window.eight.translationEngine.strings.isUnavailable;
            });
            magicBtn.forEach(ele => {
              ele.classList.add('hidden');
            });
          }
          else if (this.currentVariant && !this.currentVariant.available) {
            buttonText = window.eight.translationEngine.strings.soldOut;
            disabled = false; // Always enable the button
            this.buttons.forEach((btn) => {
              btn.ariaLabel = `'${this.currentVariant.title}' ${window.eight.translationEngine.strings.isSoldOut}`;
            });
            magicBtn.forEach(ele => {
              ele.classList.add('hidden');
            });
          }
          else {
            this.buttons.forEach((btn) => {
              btn.classList.remove("opacity-20", "added-btn");
            });
            buttonText = `<svg data-aid="icon-bag" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 15 15" fill="none" class=" inline-block">
      <g clip-path="url(#clip0_152_300)">
      <path d="M0.625 0.625C0.45924 0.625 0.300269 0.690848 0.183058 0.808058C0.065848 0.925268 0 1.08424 0 1.25C0 1.41576 0.065848 1.57473 0.183058 1.69194C0.300269 1.80915 0.45924 1.875 0.625 1.875H1.7375C1.82835 1.87516 1.91685 1.90384 1.99053 1.95699C2.0642 2.01014 2.11933 2.08509 2.14812 2.17125L4.20875 8.35437C4.30063 8.62937 4.31188 8.92438 4.24188 9.20563L4.0725 9.885C3.82312 10.8813 4.59875 11.875 5.625 11.875H13.125C13.2908 11.875 13.4497 11.8092 13.5669 11.6919C13.6842 11.5747 13.75 11.4158 13.75 11.25C13.75 11.0842 13.6842 10.9253 13.5669 10.8081C13.4497 10.6908 13.2908 10.625 13.125 10.625H5.625C5.38125 10.625 5.225 10.425 5.28438 10.1894L5.4125 9.67812C5.43409 9.59165 5.48394 9.51486 5.55414 9.45994C5.62434 9.40503 5.71087 9.37513 5.8 9.375H12.5C12.6313 9.37516 12.7594 9.33395 12.866 9.25721C12.9725 9.18047 13.0522 9.07211 13.0938 8.9475L14.7594 3.9475C14.7907 3.85354 14.7992 3.75349 14.7842 3.6556C14.7693 3.5577 14.7313 3.46476 14.6733 3.38443C14.6154 3.30411 14.5392 3.2387 14.4511 3.19359C14.3629 3.14849 14.2653 3.12498 14.1663 3.125H4.09687C4.00592 3.12497 3.91728 3.09635 3.84348 3.04319C3.76968 2.99003 3.71446 2.91501 3.68562 2.82875L3.09312 1.0525C3.05166 0.927996 2.97205 0.819704 2.86559 0.742973C2.75914 0.666243 2.63123 0.624968 2.5 0.625H0.625ZM5 12.5C4.66848 12.5 4.35054 12.6317 4.11612 12.8661C3.8817 13.1005 3.75 13.4185 3.75 13.75C3.75 14.0815 3.8817 14.3995 4.11612 14.6339C4.35054 14.8683 4.66848 15 5 15C5.33152 15 5.64946 14.8683 5.88388 14.6339C6.1183 14.3995 6.25 14.0815 6.25 13.75C6.25 13.4185 6.1183 13.1005 5.88388 12.8661C5.64946 12.6317 5.33152 12.5 5 12.5ZM12.5 12.5C12.1685 12.5 11.8505 12.6317 11.6161 12.8661C11.3817 13.1005 11.25 13.4185 11.25 13.75C11.25 14.0815 11.3817 14.3995 11.6161 14.6339C11.8505 14.8683 12.1685 15 12.5 15C12.8315 15 13.1495 14.8683 13.3839 14.6339C13.6183 14.3995 13.75 14.0815 13.75 13.75C13.75 13.4185 13.6183 13.1005 13.3839 12.8661C13.1495 12.6317 12.8315 12.5 12.5 12.5Z" fill="white"/>
      </g>
      <defs>
      <clipPath id="clip0_152_300">
      <rect width="15" height="15" fill="currentColor"/>
      </clipPath>
      </defs>
    </svg><span data-armada-button-text="" class="button-text">${window.eight.translationEngine.strings.addToCart}</span>`;
          }
          let notifyBtn = document.querySelectorAll('#add-to-cart-form .BIS_trigger');
          if (this.currentVariant) {
            if (document.querySelector('.variant-sku .sku-text')) {
              document.querySelector('.variant-sku .sku-text').innerText = this.currentVariant.sku;
            }

          }

          this.buttons.forEach((btn) => {
            btn.innerHTML = buttonText;
            btn.disabled = disabled; // This will always be false now
            if (this.currentVariant) {
              if (!this.currentVariant.available && notifyBtn.length > 0) {
                btn.classList.add("hidden");
              } else {
                btn.classList.remove("hidden");
              }
            }
          });
          notifyBtn.forEach((btn) => {
            if (this.currentVariant) {
              if (!this.currentVariant.available && notifyBtn.length > 0) {
                btn.classList.remove("hidden");
              } else {
                btn.classList.add("hidden");
              }
            }
          });
          if (this.currentVariant && this.currentVariant.available) {
            magicBtn.forEach(ele => {
              ele.classList.remove('hidden');
            });
          }
          if (reset) {
            this.buttonWraps.forEach((btnWrap, index) => {
              btnWrap.innerHTML = this.buttons[index].outerHTML;
              // append notify me btn
              btnWrap.innerHTML += `<div class="BIS_trigger cursor-pointer hidden text-16 md:text-22 font-heading heading-case leading-none text-center min-w-[132px] min-h-[37px] md:min-w-[197px] md:min-h-[45px] py-[13px] px-4 inline-block border transition-colors duration-500 relative z-10 armament-button text-body border-black armament-button--outline focus:disabled:text-body btn add-to-cart w-full BIS_trigger">
          <svg data-aid="icon-email" fill="none" width="21px" height="20px" viewBox="0 0 21 20" xmlns="http://www.w3.org/2000/svg" class=" inline-block">
            <path d="M18.7919 5.625V14.375C18.7919 14.8723 18.5943 15.3492 18.2427 15.7008C17.8911 16.0525 17.4142 16.25 16.9169 16.25H4.41687C3.91959 16.25 3.44268 16.0525 3.09105 15.7008C2.73941 15.3492 2.54187 14.8723 2.54187 14.375V5.625M18.7919 5.625C18.7919 5.12772 18.5943 4.65081 18.2427 4.29917C17.8911 3.94754 17.4142 3.75 16.9169 3.75H4.41687C3.91959 3.75 3.44268 3.94754 3.09105 4.29917C2.73941 4.65081 2.54187 5.12772 2.54187 5.625M18.7919 5.625V5.8275C18.7919 6.14762 18.71 6.46242 18.5539 6.74191C18.3978 7.0214 18.1728 7.25628 17.9002 7.42417L11.6502 11.27C11.3545 11.4521 11.0141 11.5485 10.6669 11.5485C10.3196 11.5485 9.9792 11.4521 9.68354 11.27L3.43354 7.425C3.16097 7.25711 2.93593 7.02224 2.77984 6.74275C2.62376 6.46325 2.54183 6.14845 2.54187 5.82833V5.625" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>Notify Me</div>`;
            });

            this.buttons = this.querySelectorAll('[data-name="product-submit"][data-product-form-block="true"]');
            this.buttons.forEach((btn) => {
              btn.addEventListener('click', this.handleButtonClick.bind(this));
            });
          }
        }
        else if (mode === 'loading') {
          this._buttons = this.buttons;
          this.buttonWraps.forEach((btnWrap) => {
            btnWrap.innerHTML = this.loadingButtonHtml;
          });
        }
        else if (mode === 'added') {
          this._buttons.forEach((_btn) => {
            _btn.textContent = window.eight.translationEngine.strings.added;
            _btn.ariaLabel = window.eight.translationEngine.strings.successfully;
            _btn.disabled = true;
            _btn.classList.add("opacity-20", "added-btn");
          });

          this.buttonWraps.forEach((btnWrap, index) => {
            btnWrap.innerHTML = this._buttons[index].outerHTML;
          });
        }
      }

      get product() {
        return window.eight.safeJSONParse(this.getAttribute('product'));
      }

      get scopeId() {
        return this.getAttribute('scope-id');
      }

      get isQuickAdd() {
        return this.getAttribute('quick-add') === 'true';
      }

      get isStickyForm() {
        return this.getAttribute('data-armada-sticky-form');
      }

      get quantity() {
        return this.querySelector('input[name="quantity"]:not(#quantity-no-js-quantity)') ? this.querySelector('input[name="quantity"]:not(#quantity-no-js-quantity)').value : 1;
      }

      get sellingPlanId() {
        return new FormData(this.querySelector('form')).get('selling_plan');
      }

      get cartTypePage() {
        return document.querySelector('body').getAttribute('data-armada-cart-type-page');
      }

      get cartPageUrl() {
        return document.querySelector('body').getAttribute('data-cart-url');
      }

      get forceSelection() {
        return this.getAttribute('force-selection') === 'true';
      }

      get basicSelect() {
        return this.querySelector('select[data-armada-selector^="basic-product-select-"]')
      }

      get installmentsSelect() {
        return this.querySelector('[data-armada-selector="installments-select"]');
      }

      get summaryPriceIsHidden() {
        return this.getAttribute('summary-price-hidden') === 'true';
      }

      get radioGroups() {
        let groups = [];

        for (let index = 1; index <= this.product.options.length; index++) {
          const elems = this.querySelectorAll(`[name="${this.sectionId}-product-${this.product.id}-option-${index}"]`);
          if (elems.length > 0) groups.push(elems);
        }

        return groups;
      }

      get optionType() {
        return this.getAttribute('option-type') ? this.getAttribute('option-type') : 'dropdowns';
      }

      get optionIndexes() {
        if (!this.optionInputs) return false;

        let indexes = [];

        if (this.optionType === 'dropdowns') {
          Array.from(this.optionInputs).forEach((s) => {
            // Disregard disabled option, that is the 'label inside select' feature.
            const selIndex = s.options[0].disabled === true ? s.selectedIndex - 1 : s.selectedIndex;
            indexes.push(selIndex);
          });
        }
        else if (this.optionType === 'buttons') {
          this.radioGroups.forEach((group) => {
            Array.from(group).forEach((s, radioIndex) => {
              if (s.checked) {
                indexes.push(radioIndex);
              }
            });
          });
        }

        return indexes;
      }

      get optionVals() {
        if (!this.optionInputs) return false;

        if (this.optionType === 'dropdowns') {
          return Array.from(this.optionInputs).map((s) => s.value);
        }
        else if (this.optionType === 'buttons') {
          let radioVals = [];

          this.radioGroups.forEach((group, index) => {
            const checkedVal = Array.from(group).filter(s => s.checked).map((s) => s.value);
            radioVals[index] = checkedVal[0] ? checkedVal[0] : '';
          });

          return radioVals;
        }
      }

      get allOptionsChosen() {
        if (this.optionVals.length > 0) {
          // Return true if any option is selected (including just color)
          return this.optionVals.some((v) => v !== '');
        }
        else if (this.basicSelect) {
          return this.basicSelect.value > '' ? true : false;
        }

        return false;
      }

      getNonColorOptionVals() {
        if (!this.optionInputs || !this.product) return false;

        const colorIdentifiers = ['color', 'colour', 'couleur', 'colore', 'farbe', '색', '色', 'färg', 'farve'];
        const nonColorOptionVals = [];

        if (this.optionType === 'dropdowns') {
          Array.from(this.optionInputs).forEach((select, index) => {
            const optionName = this.product.options[index];
            const isColorOption = colorIdentifiers.some(identifier =>
              optionName.toLowerCase().includes(identifier.toLowerCase())
            );

            if (!isColorOption) {
              nonColorOptionVals.push(select.value);
            }
          });
        }
        else if (this.optionType === 'buttons') {
          this.radioGroups.forEach((group, index) => {
            const optionName = this.product.options[index];
            const isColorOption = colorIdentifiers.some(identifier =>
              optionName.toLowerCase().includes(identifier.toLowerCase())
            );

            if (!isColorOption) {
              const checkedVal = Array.from(group).filter(s => s.checked).map((s) => s.value);
              nonColorOptionVals.push(checkedVal[0] ? checkedVal[0] : '');
            }
          });
        }

        return nonColorOptionVals;
      }

      get blockOrder() {
        const order = this.getAttribute('block-order') ? this.getAttribute('block-order') : 'title,price,options,quantity,payment-buttons';
        return order && order.length > 0 ? order.split(',') : false;
      }

      get blocks() {
        if (!this.blockOrder) return false;

        const blocks = this.blockOrder.map((blockName) => {
          return this.templateContent.querySelector(`[data-name="${blockName}"]`);
        });

        return blocks;
      }

      get hasBlocks() {
        // Denotes whether blocks have been appended to the product form element
        return this.getAttribute('has-blocks') === 'true';
      }
    }

    window.customElements.define('product-form', ProductForm);

  })();

  /******/
})()
  ;